import React from 'react';
import slug from 'constants/slug';
import { create } from 'api/facilityDeviceApi';
import { getOne as getFacility } from 'api/cosoApi';
import Message from 'rc-message';
import FacilityDeviceForm from '../FacilityDeviceForm';
import { getQueryString } from 'utils/fnUtil';
import PageLockHOC from 'hoc/pageLock';

@PageLockHOC(['facilityDevice.write'])
export default class FacilityDeviceCreate extends React.Component {
  static propTypes = {};

  state = {
    isLoaded: false,
    isLoading: false,
    facility: null,
    facilityId: '',
  };

  async checkValidate() {
    const queryString = getQueryString(this.props.location.search);
    const _id = queryString.facilityId;

    if (_id) {
      const res = await getFacility(_id);

      if (res.success) {
        this.setState({
          facility: res.data,
          facilityId: res.data._id,
          isLoading: false,
          isLoaded: true,
        });
      }
    }
  }

  async componentWillMount() {
    await this.checkValidate();
  }

  handelSubmit = async (values) => {
    this.setState({ isLoading: true });

    const res = await create(_.pickBy(values, _.identity));
    if (res.success && res.data) {
      Message.success({ content: 'Thành Công' });
      this.props.history.push(slug.FACILITY_DEVICE.VIEW_WITH_ID + res.data._id);
    }
    if (res.error) Message.error({ content: res.message });
  };

  render() {
    return (
      <div>
        {this.state.isLoaded && (
          <FacilityDeviceForm
            slugBack={slug.FACILITY_DEVICE.LIST}
            facility={this.state.facility ? this.state.facility : null}
            handelSubmit={this.handelSubmit}
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/FacilityDeviceContainer/FacilityDeviceCreate/index.js